/**
 * 보안 메모장 페이지
 * SecureNotesContext와 FolderContext 통합
 */

import React from 'react';
import { SecureNotesProvider } from '../contexts/SecureNotesContext';
import { FolderProvider } from '../contexts/FolderContext';
import SecureNotes from '../components/SecureNotes/SecureNotes';

function SecureNotesPage() {
  return (
    <FolderProvider>
      <SecureNotesProvider>
        <SecureNotes />
      </SecureNotesProvider>
    </FolderProvider>
  );
}

export default SecureNotesPage;